"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileUploadPrivacy = void 0;
var FileUploadPrivacy;
(function (FileUploadPrivacy) {
    FileUploadPrivacy["PRIVATE"] = "PRIVATE";
})(FileUploadPrivacy = exports.FileUploadPrivacy || (exports.FileUploadPrivacy = {}));
